<template>
    <div class="hello">
        <div class="filter">
        <input type="text" placeholder="输入编号或关键词查询, 点击图片查看简介"  v-model='searchKey' >
    </div>
        <div class="v-item" v-for="(item, index) in filterItem" :class='{"sort":item.sort,"active":item.select}' v-if="!item.sort">
            <div class="v-tiem-box">
                <div class="imgbox preview-img" @click="$preview.open(index, filterItem,options)">
                    <span class="see">
                        <img :src="`./img/icon/see.svg`" class="q_view" alt="">
                    </span>
                     <span class="poll">
                        【{{item.id}}】 {{item.name}}
                    </span>
                    <img :src="`./img/0${item.id}.jpg`" alt="" class="u-img">
                </div>
                <h2 class="v-tiem-tt" style="text-align: center;">
                    ({{statistics[item.id] || 0}})
                </h2>
                <!-- 按钮状态  三种形态-->
                <span class="btn" v-show="!redo &&!over" @click='item.select = item.select==item.id ? "" :item.id'>
                    <em v-show="item.select!=item.id && !redo">投票
                    </em>
                    <em v-show="item.select==item.id && !redo">取消投票</em>
                </span>
                <span class="btn active" v-show="item.select==item.id && redo">
                    <div class="heart heartAnimation" id="like1" rel="unlike" style=""></div>
                    <em style="z-index: 1;position: relative;">已投</em>
                </span>
                <span class="btn disabled" v-show="item.select!=item.id && redo">
                    <em>不可投票</em>
                </span>
            </div>
        </div>
        <div class="submit-box" v-if="!redo &&!over" @click="submit">
            <span class="aux">
                已选择 {{validation.count}} /10
            </span>
            <div class="u-btn" :class='{"disable":!validation.isValid,}' v-if="!loading"> 提交 </div>
            <div class="u-btn disable" v-if="loading">提交中...</div>
        </div>
        <div class="submit-box move" v-if="redo || over" @click="submit">
            <router-link :to='{path:"/poster"}' class="u-btn" @click="golottery"> 创建我的代言海报 </router-link>
        </div>
        <div id="dialog" class="dialog js-is-active" v-if="alertData.show">{{alertData.msg}}</div>
    </div>
</template>
<script>
import store from '@/assets/data';


export default {
    name: 'hello',
    data() {
        return {
            alertData: {
                show: false,
                msg: '',
                skin: 'default',
                timeout: null
            },
            loading: false,
            list: store.list,
            isSubmit: false,
            redo: 0,
            over:false,
            id: '',
            statistics: {},
            fullShow: false,
            searchKey: '',
            options: {
                shareEl: false,
                fullscreenEl: false
            }
        }
    },
    created() {
        this.startStatistics();
        this.fetchData();
        this.isRid();
        this.isEnd();
    },
    computed: {
        openid() {
            let openid = localStorage.openid || store.fmtUrl().openid;
            console.log(openid)
            if(openid==4){
                openid = Math.floor(Math.random()*10)+Date.now();
                localStorage.openid = openid;
            }

            return openid || ''
        },
        subscibe() {
            return store.fmtUrl().subscribe * 1 || 0
        },
        filterItem() {
            var key = this.searchKey;
            var result = [];
            if (key == '') {
                return this.list
            }
            this.list.map((item) => {
                var text = item.id + item.name;
                if (text.indexOf(key) != -1) {
                    result.push(item);
                }
            })
            return result;
        },
        validation() {
            var count = 0;
            var list = this.list;
            list.map((item) => {
                if (item.select) {
                    count++
                }
            })
            return {
                count: count,
                isValid: count == 10
            }
        }
        
    },
    methods: {
        isEnd() {
            var endTime = Date.parse('2019/04/24 17:00:00');
            var nowTime = Date.now();
            if (nowTime > endTime) {
                this.showMsg('投票已结束.');
               this.over = true;
            }
            
        },
        isRid(opt) {
            let day = new Date().getDate();
            if (opt) {
                if (window.localStorage) localStorage[this.openid] = day;

            } else {

                if (localStorage[this.openid] && localStorage[this.openid] == day) this.redo = 1;
            }
        },
        fetchData() {
            if (!this.openid) {
                return;
            }
            var _this = this;
            let day = new Date().getDate();

            if (window.localStorage && localStorage[this.openid]) {
                if (this.redo) {
                    this.showMsg('您今天已经投了10票了,明天再来吧!');
                }
                return store.ajax({
                    url: store.url.statistics, //请求地址
                    type: "POST", //请求方式
                    data: { openid: _this.openid }, //请求参数
                    dataType: "json",
                    success: function(response) {
                        var json = JSON.parse(response);
                        json.data = json.data || {};
                        _this.statistics = Object.assign(_this.statistics, json.data)
                    },
                    fail: function(status) {
                        this.loading = false;
                        _this.showMsg('网络错误,请刷新重试.');
                    }
                });
            } else {
                store.ajax({
                    url: store.url.voteInfo, //请求地址
                    type: "POST", //请求方式
                    data: { openid: _this.openid }, //请求参数
                    dataType: "json",
                    success: function(response) {
                        var json = JSON.parse(response);
                        _this.redo = json.redo;
                        if (json.status) {
                            _this.showMsg(json.msg);
                        }
                        if (json.redo >= 1) {
                            _this.showMsg('您已经投过来票了,明天再来吧');
                        }
                        json.data = json.data || {};

                        _this.statistics = Object.assign(_this.statistics, json.data)

                    },
                    fail: function(status) {
                        this.loading = false;
                        _this.showMsg('网络错误,请刷新重试.');
                    }
                });

            }


        },
        startStatistics() {
            var result = {};
            this.list.map((item) => {
                result[item.id] = 0;
            })
            this.statistics = result;
        },
        showMsg(msg) {
            var alert = this.alertData;
            alert.msg = msg;
            alert.show = true;
            alert.timeout = null;
            alert.timeout = setTimeout(function() {
                alert.show = false;
                alert.timeout = null;
            }, 3000);
        },
        submit(id) {

            if (this.redo > 1) {
                this.showMsg('您今天已经投了10票了,明天再来吧!');
                return;
            }

            if (!this.validation.isValid) {
                this.showMsg('请选择10个选项进行投票!');
                return;
            }

            var _this = this;
            this.loading = true;
            store.ajax({
                url: store.url.vote, //请求地址
                type: "POST",
                data: {
                    openid: _this.openid,
                    lists: store.fmtData()
                }, //请求参数
                dataType: "json",
                success: function(response) {
                    _this.loading = false;
                    var json = JSON.parse(response);
                    if (json.status == 0) {
                        _this.isRid(1)
                        _this.redo = 1;
                        store.list.map(function(item) {
                            if (item.select) {
                                _this.statistics[item.select] = _this.statistics[item.select] || 0;
                                _this.statistics[item.select] += 1;
                            }


                        })
                        _this.showMsg('投票成功');


                    } else {
                        _this.showMsg(json.msg);
                    }

                },
                fail: function(status) {
                    this.loading = false;
                }
            });
        },
        golottery() {
            this.$router.replace({ path: '/vote' })
        }
    },
    components: {

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.hello {
    overflow: hidden;
}

.input-box .tt {
    display: block;
    font-size: 12px;
    color: #666;
    margin-bottom: 5px;
}

.input-box {
    padding: 10px;
    background-color: #f8f8f8;
    margin-bottom: 10px;
}

.input-box input {
    width: 100%;
    border: 0;
    line-height: 35px;
    padding: 5px
}

.input input:foucs {
    border-bottom: 1px solid #ccc;
}

.swiper-container.swiper-container-full {
    visibility: visible;
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.75);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    white-space: nowrap;
    z-index: 99999;
}

.swiper-container-full.isShow {}

.swiper-container-full .swiper-slide {
    height: 100%;
    width: 100%;
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    display: table;
}

.slide-box {
    display: table-cell;
    vertical-align: middle;
}

.v-item {
    padding: 5px;
    width: 50%;
    float: left;
    position: relative;
    -webkit-transition: all .4s;

    background-color: #fff;

}

.v-item-sort {
    margin: 15px;
}

.v-item .btn {

    display: inline-block;
    width: 80%;
    margin-left: 10%;
    background-color: #069BE4;
    text-align: center;
    padding: 6px 5px;
    font-size: 12px;
    margin-top: 5px;
    color: #fff;
    border-radius: 4px;
    -webkit-transition: 0.35s;
    -moz-transition: 0.35s;
    transition: 0.35s;
}

.v-item.active .btn {
    background-color: #64b532;
}

.v-item .btn.disabled {
    background-color: #ccc;
}

.v-item .btn em {
    font-style: normal;
}

.v-item .btn.active {
    background-color: #e2264d;
}

/*.v-item .btn:active {
    background-color: #00AAEE;
}*/

.v-tiem-tt {

    font-size: 12px;
}

.intro {
    margin: 10px 0;
    padding: 10px;
    line-height: 1.5;
}

.vote-list {
    overflow: hidden;
}

.vote-list li {
    width: 50%;
    float: left;
    padding: 5px;
}

.v-item .imgbox {
    display: inline-block;
    width: 100%;
    height: 120px;
    -webkit-background-size: cover;
    background-size: cover;
    background-position: center center;
    overflow: hidden;
}

.author {
    display: block;
    margin-top: -6px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #333
}

.vote-list .active {
    background-color: #f5f5f9;
}

.v-item.active .v-tiem-tt {}

.u-img {
    width: 100%;
    height: auto;
}

.submit-box {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    z-index: 100;
}

.submit-box .u-btn {
    display: block;
    background-color: #64b532;
    height: 45px;
    text-align: center;
    color: #fff;
    font-size: 20px;
    line-height: 45px;
}

.submit-box.move .u-btn {
    background-color: #4bbdf0;
}

.submit-box .aux {
    position: absolute;
    right: 8px;
    top: 15px;
    color: #fff;
    font-size: 12px;
}

.v-item.sort {
    float: none;
    width: 100%;
    overflow: hidden;
}

.v-item.open {
    -webkit-box-shadow: 1px 1px 10px 2px #CCC;
}

.v-item.open .v-tiem-tt {
    border-bottom: 1px solid #eee;
}

.u-btn.disable,
.btn.disable {
    background-color: #ccc
}

.hello {
    padding-bottom: 60px;
}

.icon-arrowdown {
    -webkit-transition: 0.35s;
    transition: 0.35s;
    position: absolute;
    right: 15px;
    color: #666;
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
}

.icon-succeed {
    -webkit-transition: 0.35s;
    transition: 0.35s;
    color: #999;
    position: absolute;
    right: 35px;
    font-size: 18px;
}

.v-item.open .icon-arrowdown {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
}

.v-item.active .icon-succeed:before {
    content: "\e62d";
    color: #00AAEE
}

.dialog {
    -webkit-transition: .5s;
    transition: .5s;
    visibility: hidden;
    opacity: 0;
    position: fixed;
    left: 50%;
    top: 50%;
    text-align: center;
    max-width: 80%;
    padding: 15px;
    background: rgba(0, 0, 0, .7);
    color: #fff;
    font-size: 14px;
    line-height: 1.5;
    -webkit-border-radius: 8px;
    border-radius: 8px;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 999
}

.dialog.js-is-active {
    visibility: visible;
    opacity: 1
}

.c999 {
    color: #999;
    font-size: 14px;
    vertical-align: top;
}

.imgbox {
    position: relative;
}

.poll {
    position: absolute;
    color: #fff;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    bottom: 0;
    padding: 3px 5px;
    font-size: 12px;
    /*text-align: center;*/
}

.q_view{
    border-radius: 3px;
    background-color: rgba(0,0,0,.7);
    opacity: 0.6;
    padding:5px;
    position: absolute;
    width: 30px;
    height:    30px;
    right: 5px;
    top: 5px;
}
.filter {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: rgba(200, 200, 200, 0.6);
    z-index: 999;
    padding: 5px
}

.filter input {
    width: 100%;
    padding-left: 5px;
    line-height: 23px;
    border: 1px solid #eee;
    font-size: 12px;
}

.heart {
    background: url(http://www.17sucai.com/preview/11/2016-02-16/喜欢/images/web_heart_animation.png);
    background-position: left;
    background-repeat: no-repeat;
    height: 100px;
    width: 100px;
    cursor: pointer;
    position: absolute;
    bottom: -30px;
    left: 50%;
    margin-left: -50px;
    background-size: 2900%;
}

.heart:hover,
.heart:focus {
    background-position: right;
}

@-webkit-keyframes heartBlast {
    0% {
        background-position: left;
    }

    100% {
        background-position: right;
    }
}

@keyframes heartBlast {
    0% {
        background-position: left;
    }

    100% {
        background-position: right;
    }
}

.heartAnimation {
    display: inline-block;
    -webkit-animation-name: heartBlast;
    animation-name: heartBlast;
    -webkit-animation-duration: .8s;
    animation-duration: .8s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-timing-function: steps(28);
    animation-timing-function: steps(28);
    background-position: right;
}


@-webkit-keyframes move {
    0% {
        opacity: 0.7;


        -webkit-transform: scale(1.2) translate(0, -10px) translateZ(0);


    }

    50% {
        -webkit-transform: scale(0.6) translate(0, 5px) translateZ(0);


    }

    100% {
        opacity: 1;
        -webkit-transform: scale(1) translate(0, 0) translateZ(0);
    }
}

.move {
    -webkit-animation: move 0.5s ease-out;
}

.pswp__caption .pswp__caption__center{font-size: 12px;}
.pswp__caption .pswp__caption__center .aux{font-size: 14px;color: #fff;}
</style>